import { rankingList } from '@/mocks/manga';
import SectionHeader from './SectionHeader';

export default function RankingSection() {
  const top = rankingList[0];

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="人气榜单"
          title="本周人气排行榜"
          desc="看看大家都在飞飞漫画网追哪些作品，翻页流畅，热门佳作一网打尽。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="relative overflow-hidden rounded-lg lg:row-span-2">
            <img
              src="https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20young%20fighter%20in%20a%20heroic%20victory%20pose%20with%20bursting%20orange%20flame%20energy%20behind%20him%2C%20dramatic%20high%20contrast%20lighting%2C%20bold%20shonen%20action%20style%2C%20cinematic%20composition%20digital%20painting&width=600&height=800&seq=rank-top-banner&orientation=portrait"
              alt="本周人气榜首 热血武道传"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-trophy-fill"></i>
                本周第一
              </span>
              <h3 className="font-heading mt-2 text-2xl text-white">{top.title}</h3>
              <p className="mt-1 text-xs text-white/75">{top.author} · {top.views}人气</p>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-2">
            {rankingList.slice(1).map((item) => (
              <article
                key={item.rank}
                className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-transform duration-200 hover:-translate-y-0.5 cursor-pointer"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                    item.rank === 2
                      ? 'bg-secondary-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-400 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <img
                  src={item.cover}
                  alt={`${item.title}封面`}
                  className="h-14 w-11 shrink-0 rounded-md object-cover object-top"
                />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-bold text-foreground-950">{item.title}</div>
                  <div className="truncate text-xs text-foreground-600">{item.author}</div>
                </div>
                <div className="flex shrink-0 items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-eye-line"></i>
                  {item.views}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}